import { SpraValidationAfterSalesAdmin } from "./master";
import { Counter } from "./product";

export class Ops {
    public OpsId: number;
    public OpsNum: string;
    public TempOpsNum: string;
    public OpsDate: string;
    constructor(){
        this.OpsId = 0;
        this.OpsNum = "";
        this.TempOpsNum = "";
        this.OpsDate = "";

    }
    
}


export class OpsDetailParams {
    public StateId: number;
    public BillSubSegment: string;
    public DispatchWareHouseId: number;
    public DispatchWareHouseStateId: number;
    public ExecutiveId: number;
    public PoRefNo: string;
    public PoDate: string;
    public PoDucument: FormData;
    constructor(
    ) {
        this.StateId = 0;
        this.BillSubSegment = "";
        this.DispatchWareHouseId = 0;
        this.ExecutiveId = 0;
        this.DispatchWareHouseStateId = 0;
        this.PoRefNo = "";
        this.PoDate = "";
        this.PoDucument = new FormData();
    }
}


export class  PaymentTerm{
    public Term: string;
    public RevenueTerm?: string;        
    public CreditDays: number;
    constructor(
        ) {
            this.Term = "Advance";
            this.CreditDays = 0;
            // this.Amount = 0.0;
            // this.SlipNo = "";
            // this.SlipDate = "";
            // this.GeneralRemark = "";
            // this.BankGaurantee = "";
            // this.BGOnNationalBank = "";
        }
}

export class PaymentTermParams extends PaymentTerm{
    public Amount?: number;
    public SlipNo?: string;
    public SlipDate?: string;
    public GeneralRemark?: string;
    public BankGaurantee?: string;
    public BGOnNationalBank?: string;
    public IsForSpra: boolean;
    constructor(
    ) {
        super();
        this.IsForSpra = false;
    }
}

export class OpsProductDetail {

    public OpsId: number;
    public ProductId: number;
    public ProdMakeId: number;
    public ProdSegmentId: number;
    public ProductGroupId: number;
    public HsnCode: number;
    public GradeId: number;
    public UnitPrice?: number;
    public Quantity?: number;
    public PriceList?:number;
    public WorkSheetNSP?:number;
    public WorkSheetLanded?:number;
    public BookingLanded?:number;
    public UnitSalePrice?:number;
    public UnitWSCost?:number;
    public SaleAmount?:number;

   
    constructor() {
        this.OpsId = 0;
        this.ProductId = 0;
        this.ProdMakeId = 0;
        this.ProdSegmentId = 0;
        this.ProductGroupId = 0;
        this.HsnCode = 0;
        this.GradeId = 0;
        // this.PriceList = 0;
        // this.WorkSheetNSP = 0;
        // this.WorkSheetLanded = 0;
        // this.BookingLanded = 0;
        // this.UnitSalePrice = 0;
        // this.UnitWSCost = 0;
        // this.SaleAmount = 0;
    }

}


export class SPRAPriceRef {
     //Added Byrahul yadav on
     public OfficeId:number;
     public SPRAId:number;
     public Salecode:string;
     public RefId:number;
     public CompanyId:number;
    constructor(  ) {
        this.OfficeId=0;
         this.SPRAId=0;
        this.Salecode="";
        this.CompanyId=0;
         this.RefId=0;
    }
}

export class SpraApprovalParams {
    public PriceRefType:string;
    public PriceRef: string;
    public TotalCustMif?: number;
    public SharpMifCustomerPlace?: number;
    public CustomerDistance?: number;
    public DayOneCSA: boolean;
    public WarrantyMonth?: number;
    public WarrentyCost?: number;
    public ExtraWarrentyPeriod?: number;
    public WarrentyPercentage?: number;    
    public BlackA3CopyRatio?: number;    
    public ColorA3CopyRatio?: number;    
    public RentalTermAccept:string;
    public TOI:string;
    public IncentiveSales:string;
    public IncentiveDealer:string;
    public OverDue:string;
    public ConsValueThisMonth:number;
    public ECOC:string;
   
    constructor(
    ) {
        this.PriceRefType = "New"
        this.PriceRef = "";
        this.TotalCustMif = 0;
        this.SharpMifCustomerPlace = 0;
        //this.CustomerDistance = 0;
        this.DayOneCSA = false;
        this.RentalTermAccept = "No";
        this.ConsValueThisMonth = 0;
        this.TOI = "No";
        this.IncentiveSales = "No";
        this.IncentiveDealer = "No";
        this.OverDue = "No";
        this.ECOC = "No";
      
    }
}

export class SpraNetSalePriceRealisedParams {
    public DealerCommission: number;
    public AgentCommission: number;
    public InstallationCommission: number;
    public BuyBack: number;
    public BuyBackRemarks?: string;
    public ReSaleValueBuyBack: number;
    public BoughtOutItems: number;
    public BoughtOutItemsRemarks?: string;    
    public RebateWoGST: number;
    public FreeItem: number;
    public OtherDiscount: number;
    public PartnerId:number;
    
    constructor(
    ) {
        this.PartnerId = 0;
        this.DealerCommission = 0;
        this.AgentCommission = 0;
        this.InstallationCommission = 0;
        this.BuyBack = 0;
        this.ReSaleValueBuyBack = 0;
        this.BoughtOutItems = 0;
        this.RebateWoGST = 0;
        this.FreeItem = 0;
        this.OtherDiscount = 0;
        // this.BuyBackRemarks = "";
        // this.BoughtOutItemsRemarks = "";

    }
}

export class SpraPriceJustificationParams {
    public BoRemarksBy: number;
    public BoRemarks: string;
    public HoRemarksBy?: number;
    public HoRemarks?: string;
    public IsValidation: boolean;

    constructor(
    ) {
         this.BoRemarksBy = 0;
         this.BoRemarks = "";
        // this.HoRemarks = "";
        // this.HoRemarksBy = 0;
        this.IsValidation = false;
    }
}

export class SPRACompetitionDetailParams {
    // public CompType: number;
    public CompName: string;
    public CompModel: string;
    public CompPrice?: number;
    public Tenure?: number;
    public Rent?: number;
    public IsNewRow?: boolean = false;
    public CsaRate?:Array<SPRACompetitionCsaRate>; 
    constructor() {
        // this.CompType = 1;
        this.CompName = "";
        this.CompModel = "";
        // this.CompPrice = 0;
        this.IsNewRow = false;
    }
}


export class SPRACompetitionCsaRate extends Counter  {
    Rate?:number;
    constructor(){
        super();
    }
}

export class SpraAmcvTotalValue
{
    public TotPriceList: number;
    public TotWorkSheetNSP: number;
    public TotWorkSheetLanded: number;
    public TotBookingLanded: number;   
    public TotSaleValue: number;
    constructor() {
     
        this.TotPriceList=0;
        this.TotWorkSheetNSP=0;
        this.TotWorkSheetLanded=0;
        this.TotBookingLanded=0;
        this.TotSaleValue=0;
    }
}

export class SpraAmcvParams extends Counter {
    public EMCL?: number;
    public TotalCopy?: number;
    public TotalQtyConsumption?: number;
    public Price?: number;
    public yeild?: number;    
    public ProductId?:number;
    public ExistingAMCV?:number;
    public CounterVal?: number;
    public TotalCounterValue?: number;
    public TotalSaleValue:number;
     //added by swati on 26/03/2021
     public PriceList: number;
     public WorkSheetNSP: number;
     public WorkSheetLanded: number;
     public BookingLanded: number;   
     public TotSaleVal:number;
     public ProductCode?:string;
     public IsPriceExists:boolean;
     public IsA3RatioEntered:boolean;
     public IsTotQtyConsExists:boolean;
    constructor() {
        super();
        // this.EMCL = 0;
        // this.TotalCopy = 0;
        // this.TotalQtyConsumption = 0;
        // this.Price = 0;
        // this.ProductId = 0;
        this.TotalSaleValue=0;
        this.PriceList=0;
        this.WorkSheetNSP=0;
        this.WorkSheetLanded=0;
        this.BookingLanded=0;
        this.TotSaleVal=0;
        this.IsA3RatioEntered = false;
        this.IsTotQtyConsExists=false;
        this.IsPriceExists=false;
    }
}

export class SpraCsaRate extends Counter {
    public OrderRate?: number;
    public PriceList?: number;
    public WorkSheetLanded?: number;
    public GP?: number;
    constructor() {
        super();
        // this.OrderRate = 0;
        // this.ApprovedRate = 0;
        // this.LC = 0;
        // this.GP = 0;
    }
}

export class PriceRefCalculations{
    public Product:ProductProfitablity = new ProductProfitablity();
    public AMCV:AMCVProfitablity=new AMCVProfitablity();
    public EMI:SpraRentalEmiModel=new SpraRentalEmiModel();
    public PL:SpraRentalPL = new SpraRentalPL();
}

export class SpraRequestDetail {
    public Id: number;
    public OpsId: number;
    public OpportunityId?: number;
    public OfficeId: number;
    public EnteredBy: number;
    public CompanyId: number;
    public RefId: number;
    public ProdSegmentId: number;
    public AdvanceGroupId: number;
    public SaleType: string;
    public Period: number;
    public ValidTill: string;
    public PaymentTerm?: string;
    public ProductDetails?: string;
    public PriceApproval?: string;
    public NetSalePriceRealised?: string;
    public ComptDetail?: string;
    public Amcv?: string;
    public Remarks?: string;
    public CsaRate?: string;
    public ValidationRequired?:string;
    public Documents?:string;
    public Consignee?:string;
    public PriceRefCalculations : string;
    public IsRental:boolean;
    public ParentSpraId: number;
    public RequestNo: string;

    // public ProductDetails:Array<OpsProductDetail>;    
    // public PriceApproval:SpraApprovalParams;
    // public NetSalePriceRealised:SpraNetSalePriceRealisedParams;  
    // public ComptDetail:Array<SPRACompetitionDetailParams>;  
    // public Amcv:Array<SpraAmcvParams>;  
    // public CsaRate:Array<SpraCsaRate>;

    constructor() {
        this.Id = 0;
        this.OpsId = 0;
        this.OfficeId = 0;
        this.EnteredBy = 0;
        this.RefId = 0;
        this.CompanyId = 0;
        this.ProdSegmentId = 0;
        this.AdvanceGroupId = 0;
        this.SaleType = "LL";
        this.Period = 0;
        this.ValidTill = "";
        // this.PaymentTerm ="{}";
        // this.ProductDetails = "[]";
        // this.PriceApproval = "{}";
        // this.NetSalePriceRealised = "{}";
        // this.ComptDetail = "[]";
        // this.Amcv = "{}";
        // this.CsaRate = "[]";
        this.Remarks = "";
        this.PriceRefCalculations = "{}";
        this.IsRental = false;
        // this.ValidationRequired = "{}";
        this.ParentSpraId = 0;
        this.RequestNo ="";
    }
}

//added by swati on 08/03/2021
export class SPRASerivceRequestData {
    public SPRAId: number;
    public spraConsignee?: Array<SPRAConsigneeDetail>;
    public Mssg: string;
    public ValidateBy: number;
    public ConsigneeJSON: string;
    public ApvStatus: string;
    constructor() {
        this.SPRAId = 0;
        this.Mssg = "";
        this.ValidateBy=0;
        this.ConsigneeJSON="";
        this.ApvStatus="A";
    }
}

export class SPRAConsigneeDetail {
    public Distance: string;
    public Location: string;
    public ServiceBy: string;
    public ConsigneeAddrCode: string;
    public ConsigneeId: number;
    public ConsigneeAddress: string;
    public ContactPerson: string;
    public OfficeID: number;
    public OfficeDesc: string;
    public DealerList:any[]=[];
    public ASPId: string;
    constructor() {        
        this.Distance = "0";
        this.Location = "";
        this.ServiceBy = "";
        this.ConsigneeAddrCode="";
        this.ConsigneeAddress="";
        this.ContactPerson="";
        this.ConsigneeId=0;
        this.OfficeID=0;
        this.OfficeDesc = "";
        this.ASPId="0";
    }
}

export class SpraApprovalRemarksParams {
    public LevelID?: number;
    public AppStatus?: string;
    public ApprovedDate?: string;
    public Remarks?: string;
    public ApprovedBy?: string;
    public Tag?: number;
    public IsRequest?:number;
    constructor(
    ) {
    }
}

export class SpraApprovalDetail {
    public Id?: number;
    public SpraRequestId: number;
    public ApprovalStatus?: string;
    // public ValidateDate?: Date;
    public ValidateBy: number;
    public ValidateRemarks?: string;    
    constructor() {
        // this.Id = 0;
        this.SpraRequestId = 0;
        // this.ApprovalStatus = "";
        this.ValidateBy = 0;
        // this.ValidateRemarks = "";
    }
}

//end of addition by swati on 08/03/2021


export class SpraValidation {
    public SpraRequestApprovalValidation :SpraApprovalDetail;
    public SpraRequest:SpraRequestDetail;
    constructor(){
        this.SpraRequestApprovalValidation = new SpraApprovalDetail();
        this.SpraRequest = new SpraRequestDetail();

    }
}

export class SpraConsigneeData{
    public ConsigneeId:number;
    public ProductDetails:any[];
    public DistanceID:number;
    public Location:string;
    public ServiceBy:string
    public ASPId:number;


    constructor(){
        this.ConsigneeId = 0;
        this.ProductDetails = [];
        this.DistanceID = 0;
        this.Location = "";
        this.ServiceBy = "";
        this.ASPId = 0;


    }

}

export class SpraConsigneeRow extends SpraConsigneeData{
 public IsNewRow:boolean;
constructor(){
    super();
    this.IsNewRow = false;
}
}



export class SpraRentalAmcvParams extends Counter {
    public AgreedCSARate: number;
    public CustomerCommitmentCopy: number;
    public AgreedFreeCopy: number;
    public EMCL: number;
    public TotalCopy?: number;
    public IsA3RatioEntered:boolean;
    public StdCSARate:number;
    public CSACostRate:number;
    public ProductID:number;
    public CSAGP:number;
    public ExistingAMCV?:number;
  
    constructor() {
        super();
        this.AgreedCSARate = 0;
        this.CustomerCommitmentCopy = 0;
        this.AgreedFreeCopy = 0;
        this.EMCL = 0;
        this.IsA3RatioEntered = false;   
        this.StdCSARate=0;
        this.CSACostRate=0;   
        this.ProductID=0; 
        this.CSAGP=0;
        
    }
}

export class SpraRentalAmcvModel{
    public LeaseType:string;
    public MachineLife:number;
    public ContPeriod:number;
    public LockInMonths:number;
    public SecurityDeposite:number;
    public MonthlyRent:number;
    public RateOfInterest:number;
    public FreeCopyValue:number;
    public ResidualValue:number;
    public CounterDetail:Array<SpraRentalAmcvParams>;
    public NotionalRent:boolean;
    public NotionalInput:NotionalInput;
    constructor() {
        this.LeaseType = "Operating Lease";
        this.MachineLife = 0;        
        this.MonthlyRent = 0;
        this.ContPeriod =  0;
        this.LockInMonths=  0;
        this.SecurityDeposite = 0;
        this.ResidualValue = 0;
        this.RateOfInterest = 9;
        this.FreeCopyValue = 0
        this.CounterDetail = new Array<SpraRentalAmcvParams>();
        this.NotionalRent = false;
        this.NotionalInput = new NotionalInput();
    }
}



export class SpraEmiRow{
    public Months:number;
    public Opening:number;
    public Interest:number;
    public PrincipalMC:number;
    public Principal:number;
    public Closing:number;
    constructor(){
        this.Months = 0;
        this.Opening = 0;
        this.Interest = 0;
        this.PrincipalMC = 0;
        this.Principal = 0;
        this.Closing = 0;
    }    
}


export class EmiBaseDetail{
    public TotalRentalAmount:number;
    public LoanAmount:number;
    public RateOfInterest:number;
    public LockInMonths:number;
    public EMI:number;
    public FreeCopyValue;
    constructor(){
        this.TotalRentalAmount = 0;
        this.LoanAmount = 0
        this.RateOfInterest = 0
        this.LockInMonths = 0
        this.EMI = 0
        this.FreeCopyValue = 0;
    }
}

export class SpraRentalEmiDetail extends EmiBaseDetail{    
    public SpraEmiChart:Array<SpraEmiRow>;
    constructor(){
        super();
        this.SpraEmiChart = Array<SpraEmiRow>();
    }

}


export class SpraRentalEmiModel{    
    public EmiDetailWithOutFreeCopy:SpraRentalEmiDetail;
    public EmiDetailWithFreeCopy:SpraRentalEmiDetail;
    constructor(){
        this.EmiDetailWithOutFreeCopy = new SpraRentalEmiDetail();
        this.EmiDetailWithFreeCopy = new SpraRentalEmiDetail();

        // this.EmiDetailWithOutFreeCopy.SpraEmiChart.push(new SpraEmiRow());
        // this.EmiDetailWithFreeCopy.SpraEmiChart.push(new SpraEmiRow());
    }

}


export class SpraRentalPL{
    public PLMachineLife:number;
    // public CustCommitCopyPerMonthBW:number;
    // public CustCommitCopyPerMonthColor:number;
    // public CustCommitCopyPerMonthBWA3:number;
    // public CustCommitCopyPerMonthColorA3:number;
    // public EstMinimumCopyPerMonthBW:number;
    // public EstMinimumCopyPerMonthColor:number;
    // public EstMinimumCopyPerMonthBWA3:number;
    // public EstMinimumCopyPerMonthColorA3:number;
    // public AgreedCSARateBW:number;
    // public AgreedCSARateColor:number;
    // public AgreedCSARateBWA3:number;
    // public AgreedCSARateColorA3:number;
    // public CSACostRateBW:number;
    // public CSACostRateColor:number;
    // public CSACostRateBWA3:number;
    // public CSACostRateColorA3:number;
    public MonthlyRent:number;
    // public AgreedFreeCopyBW:number;
    // public AgreedFreeCopyColor:number;
    // public AgreedFreeCopyBWA3:number;
    // public AgreedFreeCopyColorA3:number;
    public TotalCostAmount:number;
    public ResidualValue:number;
    public PLLockInMonth:number;
    public InterestCostForPL:number[] = [];
    public YearCSARevnue :number;
    public CSACostLanded:number;
    public CSACostFreeCopies:number;
    public DepreciationVal :number;
    public InsuranceVal:number;
    public InsPerc:number;
    public BadDebtVal:number;
    public BadDebtPerc:number;
    public TotalRevnue:number;
    public CollChargesVal:number;
    public CollChargesPerc:number;
    public TotExpenses:number;
    public NoOfYears:Array<number>;
    public SumProfitWithoutInt:number;
    public SumProfitWithoutIntPerc:number;
    public SumProfitWithInt:number;
    public SumProfitWithIntPerc:number;
    public SumYearlyCSARevenue:number;
    public SumRentalRev:number;
    public TotRevenue:number;
    public SumCSAcost:number;
    public SumCSAFreeCopies:number;
    public SumDepreciation:number;
    public SumInterest:number;
    public SumInsurance:number;
    public SumBadDebt:number;
    public SumCollChargesVal:number;
    public SumTotExpenses:number;
    public InterestPL:Array<number>;
    public ProfitPer:number;
    public TotExpenseWithInt:Array<number>;
    public ProfitWithOutInt:Array<number>;
    public ProfitWithOutIntPerc:Array<number>;
    public ProfitWithInt:Array<number>;
    public ProfitWithIntPerc:Array<number>;
    public IsNotionalRent:boolean //Added by rahul yadav on 28/06/2021 in case of notional rent
    public SumOfFGQty:number //Added by rahul yadav on 28/06/2021 for sum of FG Qty
    constructor(){
        this.PLMachineLife = 0;
        // this.CustCommitCopyPerMonthBW=0;
        // this.CustCommitCopyPerMonthColor=0;
        // this.EstMinimumCopyPerMonthBW=0;
        // this.EstMinimumCopyPerMonthColor=0;
        // this.AgreedCSARateBW=0;
        // this.AgreedCSARateColor=0;
        this.MonthlyRent=0;
        // this.CSACostRateBW=0;
        // this.CSACostRateColor=0;
        // this.AgreedFreeCopyBW=0;
        // this.AgreedFreeCopyColor=0;
        this.TotalCostAmount=0;
        this.ResidualValue=0;
        this.PLLockInMonth=0;
        this.YearCSARevnue=0;
      this.MonthlyRent=0;
      this.CSACostLanded=0;
      this.CSACostFreeCopies=0;
      this.DepreciationVal=0;
      this.InsuranceVal=0;
      this.InsPerc=1;
      this.BadDebtVal=0;
      this.BadDebtPerc=5;
      this.TotalRevnue=0;
      this.CollChargesVal=0;
      this.CollChargesPerc=4;
      this.TotExpenses=0;  
      this.NoOfYears=[];
      this.SumProfitWithoutInt=0;
      this.SumProfitWithoutIntPerc=0;
      this.SumProfitWithInt=0;
      this.SumProfitWithIntPerc=0;
      this.SumYearlyCSARevenue = 0;
      
    //   this.AgreedCSARateBWA3=0;
    //   this.AgreedCSARateColorA3=0;  
    //     this.CSACostRateBWA3=0;
    //     this.CSACostRateColorA3=0;
    //     this.EstMinimumCopyPerMonthBWA3=0;
    //     this.EstMinimumCopyPerMonthColorA3=0;
    //     this.CustCommitCopyPerMonthBWA3=0;
    //     this.CustCommitCopyPerMonthColorA3=0;
    //     this.AgreedFreeCopyBWA3=0;
    //     this.AgreedFreeCopyColorA3=0;
        this.SumRentalRev = 0;
        this.TotRevenue = 0;
        this.SumCSAcost = 0;
        this.SumCSAFreeCopies = 0;
        this.SumDepreciation = 0;
        this.SumInterest = 0;
        this.SumInsurance = 0;
        this.SumBadDebt = 0;
        this.SumCollChargesVal = 0;
        this.SumTotExpenses = 0;
        this.InterestPL = new Array<number>();
        this.ProfitPer = 0;
        this.TotExpenseWithInt = new Array<number>();
        this.ProfitWithInt = new Array<number>();
        this.ProfitWithIntPerc = new Array<number>();
        this.ProfitWithOutInt = new Array<number>();
        this.ProfitWithOutIntPerc = new Array<number>();
        this.SumProfitWithoutInt = 0;
        this.SumProfitWithoutIntPerc = 0;
        this.SumProfitWithInt = 0;
        this.SumProfitWithIntPerc = 0;
        this.IsNotionalRent =false;
        this.SumOfFGQty = 0;
    }

}

export class SpraRentalPLCalculation{
    public spraRentalPL:SpraRentalPL;  
        constructor(){
            this.spraRentalPL = new SpraRentalPL();
        }

    ConvertMachineLifeToYears()
    {
        this.spraRentalPL.NoOfYears = [];
        let i:number;
        let j:number;
        i=0;
        j=this.spraRentalPL.PLMachineLife;
        while(j>=12)
        {
          this.spraRentalPL.NoOfYears.push(12);
            j=j-12;
        }
       if((j<12) && (j!=0))
       {
        this.spraRentalPL.NoOfYears.push(j);
       }
  
    }
  
    CalculateRevenue(CounterDetail:Array<SpraRentalAmcvParams>)
    { 
        
        this.spraRentalPL.YearCSARevnue  = 0;
        this.spraRentalPL.CSACostFreeCopies =0; 
        this.spraRentalPL.CSACostLanded =  0;
        CounterDetail.forEach((cd) => {
            //condition added by rahul yadav on 28/06/2021 in case of notional rent
            //multiply with  total fg qty by rahul yadav on 7/2/2021
            if(!this.spraRentalPL.IsNotionalRent){
                //  this.spraRentalPL.YearCSARevnue = this.spraRentalPL.YearCSARevnue + (((cd.CustomerCommitmentCopy+ cd.EMCL)*cd.AgreedCSARate) * (this.spraRentalPL.SumOfFGQty));
                //  this.spraRentalPL.CSACostLanded  = this.spraRentalPL.CSACostLanded + (((cd.CustomerCommitmentCopy+ cd.EMCL)*cd.CSACostRate)* (this.spraRentalPL.SumOfFGQty));
                this.spraRentalPL.YearCSARevnue = this.spraRentalPL.YearCSARevnue + (((cd.CustomerCommitmentCopy+ cd.EMCL)*cd.AgreedCSARate) * (cd.Qty));
                 this.spraRentalPL.CSACostLanded  = this.spraRentalPL.CSACostLanded + (((cd.CustomerCommitmentCopy+ cd.EMCL)*cd.CSACostRate)* (cd.Qty));
            }
            else{
                   //added by rahul yadav on 28/06/2021 to exclude CustomerCommitmentCopy from year csa revenue
            this.spraRentalPL.YearCSARevnue = this.spraRentalPL.YearCSARevnue + (((cd.EMCL)*cd.AgreedCSARate)* (cd.Qty));
            this.spraRentalPL.CSACostLanded  = this.spraRentalPL.CSACostLanded + (((cd.EMCL)*cd.CSACostRate)* (cd.Qty));
            }
            this.spraRentalPL.CSACostFreeCopies = this.spraRentalPL.CSACostFreeCopies + (( cd.AgreedFreeCopy* cd.CSACostRate )* (cd.Qty));
           
           });
    //   this.spraRentalPL.YearCSARevnue = 
    //   ((this.spraRentalPL.CustCommitCopyPerMonthBW + this.spraRentalPL.EstMinimumCopyPerMonthBW)* this.spraRentalPL.AgreedCSARateBW)
    //    + ((this.spraRentalPL.CustCommitCopyPerMonthColor + this.spraRentalPL.EstMinimumCopyPerMonthColor)* this.spraRentalPL.AgreedCSARateColor) 
  
    //    this.spraRentalPL.CSACostLanded = ((this.spraRentalPL.CustCommitCopyPerMonthBW + this.spraRentalPL.EstMinimumCopyPerMonthBW)* this.spraRentalPL.CSACostRateBW)
    //    + ((this.spraRentalPL.CustCommitCopyPerMonthColor + this.spraRentalPL.EstMinimumCopyPerMonthColor)* this.spraRentalPL.CSACostRateColor);  
  
    //    this.spraRentalPL.CSACostFreeCopies = ((this.spraRentalPL.AgreedFreeCopyBW)* this.spraRentalPL.CSACostRateBW)
    //    + ((this.spraRentalPL.AgreedCSARateColor)* this.spraRentalPL.CSACostRateColor);  
    
        this.spraRentalPL.DepreciationVal= (this.spraRentalPL.TotalCostAmount-this.spraRentalPL.ResidualValue)/this.spraRentalPL.PLLockInMonth;
  
        this.spraRentalPL.InsuranceVal = (this.spraRentalPL.DepreciationVal * this.spraRentalPL.InsPerc)/100;
        this.spraRentalPL.BadDebtVal = (this.spraRentalPL.DepreciationVal * this.spraRentalPL.BadDebtPerc)/100;
  
        this.spraRentalPL.TotalRevnue=this.spraRentalPL.YearCSARevnue + this.spraRentalPL.MonthlyRent;
        this.spraRentalPL.CollChargesVal =  (this.spraRentalPL.TotalRevnue * this.spraRentalPL.CollChargesPerc)/100;
  
        this.spraRentalPL.TotExpenses= this.spraRentalPL.CSACostLanded+ this.spraRentalPL.CSACostFreeCopies+ this.spraRentalPL.DepreciationVal+ this.spraRentalPL.InsuranceVal +this.spraRentalPL.BadDebtVal+this.spraRentalPL.CollChargesVal ;
        this.CalculateSumTotal();
        this.spraRentalPL.ProfitPer = ( this.spraRentalPL.TotalRevnue-this.spraRentalPL.TotExpenses)/ this.spraRentalPL.TotalRevnue;
        
  
      }
  
      InsPercChange(InsPer:number)
      {
        this.spraRentalPL.InsuranceVal = (this.spraRentalPL.DepreciationVal * InsPer)/100;
        this.spraRentalPL.TotExpenses= this.spraRentalPL.CSACostLanded+ this.spraRentalPL.CSACostFreeCopies+ this.spraRentalPL.DepreciationVal+ this.spraRentalPL.InsuranceVal +this.spraRentalPL.BadDebtVal+this.spraRentalPL.CollChargesVal ;
        this.CalculateSumTotal();
      }
      BadDebtPercChange(BDPer:number)
      {
        this.spraRentalPL.BadDebtVal = (this.spraRentalPL.DepreciationVal * BDPer)/100;
        this.spraRentalPL.TotExpenses= this.spraRentalPL.CSACostLanded+ this.spraRentalPL.CSACostFreeCopies+ this.spraRentalPL.DepreciationVal+ this.spraRentalPL.InsuranceVal +this.spraRentalPL.BadDebtVal+this.spraRentalPL.CollChargesVal ;
        this.CalculateSumTotal();
      }
      CollChargesPercChange(CCPer:number)
      {
        this.spraRentalPL.CollChargesVal =  (this.spraRentalPL.TotalRevnue * CCPer)/100;
        this.spraRentalPL.TotExpenses= this.spraRentalPL.CSACostLanded+ this.spraRentalPL.CSACostFreeCopies+ this.spraRentalPL.DepreciationVal+ this.spraRentalPL.InsuranceVal +this.spraRentalPL.BadDebtVal+this.spraRentalPL.CollChargesVal ;
        this.CalculateSumTotal();
      }
  
      CalculateSumTotal()
      {
        this.spraRentalPL.SumYearlyCSARevenue=0;
        this.spraRentalPL.SumRentalRev=0;
        this.spraRentalPL.TotRevenue=0;
        this.spraRentalPL.SumCSAcost=0;
        this.spraRentalPL.SumCSAFreeCopies=0;
        this.spraRentalPL.SumDepreciation=0;
        this.spraRentalPL.SumInterest=0;
        this.spraRentalPL.SumInsurance=0;
        this.spraRentalPL.SumBadDebt=0;
        this.spraRentalPL.SumCollChargesVal=0;
        this.spraRentalPL.SumTotExpenses=0;
        this.spraRentalPL.ProfitWithInt=[];
        this.spraRentalPL.ProfitWithOutInt=[];
        this.spraRentalPL.ProfitWithIntPerc=[];
        this.spraRentalPL.ProfitWithOutIntPerc=[];
        this.spraRentalPL.TotExpenseWithInt=[];
        this.spraRentalPL.SumProfitWithoutInt=0;
        this.spraRentalPL.SumProfitWithoutIntPerc=0;
        this.spraRentalPL.SumProfitWithInt=0;
        this.spraRentalPL.SumProfitWithIntPerc=0;
        this.spraRentalPL.NoOfYears.forEach((element: any,index:number) => {
          this.spraRentalPL.SumYearlyCSARevenue = this.spraRentalPL.SumYearlyCSARevenue  + (this.spraRentalPL.YearCSARevnue* element);
          this.spraRentalPL.SumRentalRev = this.spraRentalPL.SumRentalRev + (this.spraRentalPL.MonthlyRent * element);
          this.spraRentalPL.SumCSAcost= this.spraRentalPL.SumCSAcost + (this.spraRentalPL.CSACostLanded  * element)
          this.spraRentalPL.SumCSAFreeCopies = this.spraRentalPL.SumCSAFreeCopies +(this.spraRentalPL.CSACostFreeCopies * element);
          this.spraRentalPL.SumDepreciation = this.spraRentalPL.SumDepreciation + (this.spraRentalPL.DepreciationVal * element);
          this.spraRentalPL.SumInsurance = this.spraRentalPL.SumInsurance + (this.spraRentalPL.InsuranceVal * element);
          this.spraRentalPL.SumBadDebt=  this.spraRentalPL.SumBadDebt+ (this.spraRentalPL.BadDebtVal * element);
          this.spraRentalPL.SumCollChargesVal= this.spraRentalPL.SumCollChargesVal + (this.spraRentalPL.CollChargesVal * element);
         
          this.spraRentalPL.SumInterest =  this.spraRentalPL.SumInterest + (this.spraRentalPL.InterestPL[index]);
          this.spraRentalPL.TotExpenseWithInt.push((this.spraRentalPL.TotExpenses * element) +this.spraRentalPL.InterestPL[index]);
          let TotRev :number;
          TotRev= this.spraRentalPL.YearCSARevnue* element + this.spraRentalPL.MonthlyRent* element;
          this.spraRentalPL.SumTotExpenses =  this.spraRentalPL.SumTotExpenses + (this.spraRentalPL.TotExpenses * element)  + this.spraRentalPL.InterestPL[index];
          let profitWithoutInt:number=((TotRev) - ((this.spraRentalPL.TotExpenses * element) +this.spraRentalPL.InterestPL[index]));
          this.spraRentalPL.ProfitWithOutInt.push(profitWithoutInt);
          this.spraRentalPL.SumProfitWithoutInt = this.spraRentalPL.SumProfitWithoutInt + profitWithoutInt;
          this.spraRentalPL.ProfitWithOutIntPerc.push((profitWithoutInt/TotRev)*100);
          let profitWithInt:number = profitWithoutInt + this.spraRentalPL.InterestPL[index];
          this.spraRentalPL.ProfitWithInt.push(profitWithInt);
          this.spraRentalPL.SumProfitWithInt = this.spraRentalPL.SumProfitWithInt + profitWithInt;
          this.spraRentalPL.ProfitWithIntPerc.push((profitWithInt/TotRev)*100);        
          
        });
        this.spraRentalPL.TotRevenue =  this.spraRentalPL.SumYearlyCSARevenue +   this.spraRentalPL.SumRentalRev;
        this.spraRentalPL.SumProfitWithoutIntPerc = ( this.spraRentalPL.SumProfitWithoutInt/ this.spraRentalPL.TotRevenue )*100;
        this.spraRentalPL.SumProfitWithIntPerc = ( this.spraRentalPL.SumProfitWithInt/ this.spraRentalPL.TotRevenue )*100;
      }


}



export class DealerParam{
    public OfficeId:number; 
    public ProductSegmentId:number; 
    public SetNo:number;
    public NoOfItem:number;
    constructor(){
        this.OfficeId = 0;
        this.ProductSegmentId = 0;
        this.SetNo = 0;
        this.NoOfItem = 0;
    }
}
//Added By Rahul yadav on 27/05/2021 for discount view 
export class DiscountView{
    public TotalPurOrderVal:number; 
    public warrantycost:number; 
    public DealerComm:number;
    public BuyBack:number;
    public ResaleBuyBackVal:number;
    public InstallComm:number;
    public BoughtOutItmes:number;
    public RebatewoGST:number;
    public FreeItem:number;
    public Other:number;
    public NetSalePriceRealised:number;
    public IsRental:boolean;
    constructor(){
       this.TotalPurOrderVal=0;
       this.warrantycost=0;
       this.DealerComm=0;
       this.BuyBack=0;
       this.ResaleBuyBackVal=0;
       this.InstallComm=0;
       this.BoughtOutItmes=0;
       this.RebatewoGST=0;
       this.FreeItem = 0;
       this.Other = 0;
       this.NetSalePriceRealised=0;
       this.IsRental = false;
    }
}



export class NotionalCounterDetail{
    public CounterId:number;
    public CounterDesc:string;    
    public Rate:number; 
    public Commitment:number;     
    constructor(){
        this.Rate = 0;
        this.Commitment = 0;
        this.CounterId = 0;
        this.CounterDesc = "";
    }
}

export class SpraStatusReport{
    public FromDate:string;    
    public ToDate:string;  
    public  EmployeeID :number;
    public CustomerName :string;  
    public officeid  :number;
    public LogInEmployeeIdd  :number;
    public Status :string; 
    public SaleType:string;
    public ProdSegment:string
    public ProdGroup:string
    constructor(){
        this.FromDate="";
        this.ToDate="";
        this.EmployeeID=0;
        this.CustomerName="";
        this.officeid=0;
        this.LogInEmployeeIdd=0;
        this.Status='';
        this.SaleType='';
        this.ProdGroup='';
        this.ProdSegment='';
     }
}

export class SpraSearch{
    public FromDate:string;    
    public ToDate:string;  
    public CustomerName :string; 
    public SPRANumber :string;
    public IsCeha :Boolean;  

    constructor(){
        this.FromDate="";
        this.ToDate="";
        this.CustomerName="";
        this.SPRANumber="";
        this.IsCeha =false;
     }
}
export class NotionalInput{
    public Rent:number;
    public CounterDetail:Array<NotionalCounterDetail>;  
    constructor(){
        this.Rent = 0;
        this.CounterDetail=  new Array<NotionalCounterDetail>();
    }

    
}
//Added By Rahul yadav on 27/05/2021 for Consignee view 
export class ConsigneeDetails{
    public ConsigneeAddrCode:string = ""; 
    public ServiceBy:string=""; 
    public PartnerDesc:string="";
    public Distance:string="";
    constructor(){
     
    
}
}


export class ProductProfitablity{
public TotalQty:number = 0;
public TotalPrice:number = 0;
public TotalSaleValue:number = 0;
public TotalPriceList:number = 0;
public TotalWSNSP:number = 0;
public TotalLandedCost:number = 0;
public TotalBookLC:number = 0;
public TotalFinishedGoodsPrice:number = 0;
public GPPriceList:string = "0";
public GPWSNSP:string = "0";
public GPLandedCost:string = "0";
public GPBookLC:string = "0";
public TotalFGServSaleValue:number = 0;
public TotalFGServPriceList:number = 0;
public TotalFGServWSNSP:number = 0;
public TotalFGServLandedCost:number = 0;
public TotalFGServBookLC:number = 0;
public FGServGPPriceList:string = "0";
public FGServGPWSNSP:string = "0";
public FGServGPLandedCost:string = "0";
public FGServGPBookLC:string = "0";
public TotCostAmount :number = 0;
public TotSaleAmount :number = 0;
public TotLoanAmount :number = 0;
public TotDiscount:number = 0;
public ProfitBeforeTax:number = 0;
public ProfitBeforeTaxWithInt:number = 0;
public NetSaleValueVGP :number = 0;
}


export class AMCVProfitablity{
  TotalSale: number = 0;
  TotalPriceList: number= 0;
  GPSale: string= "0";
  GPPriceList: number= 0;
  GrandTotSale: number= 0;
  GrandTotPriceList: number= 0;
  TotalWSNSP: number= 0;
  TotalLandedCost: number= 0;
  TotalBookLC: number= 0;
  GPriceList: string= "0";
  GPWSNSP: string= "0";
  GPLandedCost: string= "0";
  GPBookLC: string= "0";
}
